async function authJson(path, method = 'GET', payload = null, { sessionToken = null } = {}) {
  const requestInit = {
    method,
    credentials: 'include',
    headers: {}
  };
  if (typeof sessionToken === 'string' && sessionToken) {
    requestInit.headers['X-Session-Token'] = sessionToken;
  }
  if (payload !== null) {
    requestInit.headers['Content-Type'] = 'application/json';
    requestInit.body = JSON.stringify(payload);
  }

  const response = await fetch(path, requestInit);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(typeof data?.error === 'string' ? data.error : `Request failed (${response.status})`);
  }
  return data;
}

export { authJson };
